import { render, staticRenderFns } from "./ParametersPrintTable.vue?vue&type=template&id=db2a6846&scoped=true&"
import script from "./ParametersPrintTable.vue?vue&type=script&lang=js&"
export * from "./ParametersPrintTable.vue?vue&type=script&lang=js&"
import style0 from "./ParametersPrintTable.vue?vue&type=style&index=0&id=db2a6846&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2a6846",
  null
  
)

export default component.exports